/* eslint-disable @typescript-eslint/no-explicit-any */
import { useEffect } from 'react';

export function useChunkErrorHandler() {
  useEffect(() => {
    const handleError = (event: ErrorEvent | PromiseRejectionEvent) => {
      const error = 'reason' in event ? event.reason : event.error;

      if (!error) return;

      const isChunkError =
        error.message?.includes(
          'Failed to fetch dynamically imported module'
        ) ||
        error.message?.includes('Failed to import') ||
        error.message?.includes('Loading chunk') ||
        error.message?.includes('Loading CSS chunk') ||
        error.message?.includes('ChunkLoadError') ||
        error.message?.includes('insertBefore') || // Language-independent detection
        error.message?.includes('removeChild') || // Language-independent detection
        error.message?.includes('Hydration failed') ||
        error.message?.includes('Minified React error') ||
        error.message?.includes(
          'React will try to recreate this component tree'
        ) ||
        error.message?.includes('is not a valid JavaScript MIME type') || // MIME type error
        error.message?.includes('Unexpected Application Error');

      if (isChunkError) {
        console.warn('Chunk loading error detected, reloading...');

        // Prevent default error handling (no scary messages)
        event.preventDefault();

        // Clear caches and reload immediately
        (async () => {
          try {
            // Clear service worker caches
            if ('caches' in window) {
              const cacheNames = await caches.keys();
              await Promise.all(cacheNames.map((name) => caches.delete(name)));
            }

            // Unregister service workers
            if ('serviceWorker' in navigator) {
              const registrations =
                await navigator.serviceWorker.getRegistrations();
              await Promise.all(
                registrations.map((registration) => registration.unregister())
              );
            }
          } catch (error) {
            console.error('Error clearing caches:', error);
          }

          // Reload the page
          window.location.reload();
        })();

        return true;
      }

      return false;
    };

    // Listen for both error types
    window.addEventListener('error', handleError);
    window.addEventListener('unhandledrejection', handleError as any);

    return () => {
      window.removeEventListener('error', handleError);
      window.removeEventListener('unhandledrejection', handleError as any);
    };
  }, []);
}
